// @docs https://[domain]/api/v1/docs
export default {
  List: "/master-data/ethnicities",
  ListShort: "/master-data/ethnicities/short",
};
